import { render, staticRenderFns } from "./BaseModalNew.vue?vue&type=template&id=151fe6f6&scoped=true&"
import script from "./BaseModalNew.vue?vue&type=script&lang=js&"
export * from "./BaseModalNew.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalNew.vue?vue&type=style&index=0&id=151fe6f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fe6f6",
  null
  
)

export default component.exports